import React, {useEffect, useState} from 'react';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import FeedbackTab from './FeedbackTab';
import { useDispatch, useSelector } from 'react-redux';
import { getRating } from 'redux/actions/UserTag';
import moment from 'moment';
import { feedback } from './FeedBackData';
import { dateFormate } from 'utils/utils';

function FeedbackTable() {
  const role = localStorage.getItem('role');
  const [searchParams, setSearchParams] = useSearchParams();

  const params = {};
  searchParams.forEach((value, key) => {
    params[key] = value;
  });

  const dispatch = useDispatch();
  const tableData = useSelector((state) => state?.userRating?.userRating?.data);
  const loader = useSelector((state) => state?.userRating?.loading);
  const [value, setValue] = useState('Customer');
  const [type, setType] = useState('Customer')
  const [page, setPage] = useState(params?.page ? parseInt(params?.page): 0);
  const [rowsPerPage, setRowsPerPage] = useState(params?.pageSize ? parseInt(params?.pageSize): 10);
  const [dateFrom, setDateFrom] = useState(params?.startDate ? params?.startDate : '');
  const [dateTo, setDateTo] = useState(params?.endDate ? params?.endDate : '');
  const [status, setStatus] = useState(params?.filterStatus ? JSON.parse(params?.filterStatus) : []);
  const [statusCard, setStatusCard] = useState(params?.tabStatus ? parseInt(params?.tabStatus) : '');

  const breadcrumbPaths = [
    
  ];

  let filterData = {
    type:type,
    page:page,
    pageSize:rowsPerPage,
    dateFrom:dateFrom,
    dateTo:dateTo,
    status: status?.length > 0 ?  status : statusCard
  }
  let filterDateRange = {
    dateFrom:dateFrom,
    dateTo:dateTo,
  }

  useEffect(() => {
    dispatch(getRating(filterData));
  }, []);


  const location = useLocation();
  const navigate = useNavigate();

  const onClickTableFeedback = (data) => {
    let url = window.location.pathname.split("/")[1]
    if (url === 'feedback'){
      // navigate('/feedback/details?tripId='+data?.Trip?.id+'&type='+type)
      navigate('/feedback/details', {state: {tripId: data?.Trip?.id, type}})
    }
  }

  const handleChange = (newValue) => {
    setValue(newValue);
    setType(newValue);

    dispatch(getRating({...filterData, type:newValue}));
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);

    setSearchParams({
      ...params,
      page: newPage
    });

    dispatch(getRating({...filterData, page:newPage}))
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);

    setSearchParams({
      ...params,
      pageSize: event.target.value
    });

    dispatch(getRating({...filterData, page:0, pageSize:parseInt(event.target.value)}))
  };

  const onSelectDateRange = (newValue) => {
    if(newValue === null){
      setSearchParams({...params, startDate: '', endDate: '' });
      setDateFrom('')
      setDateTo('')
      filterData = {...filterData, 
        dateFrom:'',
        dateTo:'',
        page:0
      }
    }else{
      setSearchParams({
        startDate: dateFormate(newValue[0], "MM/DD/YYYY"),
        endDate: dateFormate(newValue[1], "MM/DD/YYYY"),
      });
      setDateFrom(dateFormate(newValue[0], "MM/DD/YYYY"))
      setDateTo(dateFormate(newValue[1], "MM/DD/YYYY"))
      filterData = {...filterData, 
        dateFrom:dateFormate(newValue[0], "MM/DD/YYYY"),
        dateTo:dateFormate(newValue[1], "MM/DD/YYYY"),
        page:0
      }
    }
    dispatch(getRating(filterData));
  }

  const onFilterChange = (val) => {
    setStatus(val);
    setPage(0);
    setStatusCard('')
    filterData = {...filterData, page: 0, status: val}

    setSearchParams({
      ...params,
      filterStatus: JSON.stringify(val), 
      tabStatus: ""
    });
    dispatch(getRating(filterData));
  }

  const onRestFilter = () => {
    setStatus("")
    setStatusCard('')
    filterData = {...filterData, status:""}

    setSearchParams({
      ...params,
      filterStatus: "",
      tabStatus: "" 
    });
    dispatch(getRating(filterData));
  }

  const onRating = (rating) => {
    if(rating === statusCard){
      setStatusCard('');
      filterData = {...filterData, page: 0, status: ''};
    }else{
      setStatusCard(rating);
      filterData = {...filterData, page: 0, status: rating};
    }

    setSearchParams({
      ...params,
      filterStatus: "",
      tabStatus: rating
    });

    setPage(0);
    setStatus("");
    dispatch(getRating(filterData));
  }

  return (
    <div>
        <CommonBreadCrumb paths={breadcrumbPaths}/> 
        <FeedbackTab
          tabName={"feedback"}
          isLoading={loader}
          defaultStatus={status}
          filterData={feedback}
          onFilterChange={onFilterChange} 
          onRestFilter={onRestFilter} 
          tableData={tableData} 
          onClickTableFeedback={onClickTableFeedback}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          page={page}
          rowsPerPage={rowsPerPage}
          value={value}
          role={role}
          onSelectDateRange={onSelectDateRange}
          handleChange={handleChange}
          onRating={onRating}
          status={status}
          statusCard={statusCard}
          dateFrom={dateFrom}
          dateTo={dateTo}
        />
    </div>
  )
}

export default FeedbackTable;